import * as React from "react";
import { observer } from "mobx-react";
import { Button } from "./Button";
import { Strings } from "../Stores/StringsStore";
import { AppStore } from "../Stores/AppStore";

@observer
export class UserButton extends Button {

	render() {
		return <Button {...this.props} title={this.props.title ? this.props.title : !AppStore.context.sessionDetails.isApp ? Strings.appNavigation.userButtonTooltip : ""}>
			<i>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
					<circle cx="16" cy="10" r="8" />
					<path d="M4.08,30C4.74,25.51,9.83,22,16,22s11.26,3.51,11.92,8h2C29.29,24.39,23.3,20,16,20S2.71,24.39,2.06,30h2Z" />
				</svg>
			</i>
		</Button>;
	}
}